import {
  Bell,
  History,
  LayoutGrid,
  LineChart,
  ShoppingBag,
  Store,
  Sparkles,
  ArrowUpCircle,
  type LucideIcon,
} from 'lucide-react'

export interface AdminSection {
  path: string
  title: string
  /** Короткая подпись для нижней навигации на телефоне. */
  navLabel: string
  icon: LucideIcon
}

/// Порядок разделов повторяет `AdminSection` из Flutter-версии — по нему
/// пользователи уже привыкли водить глазом.
export const ADMIN_SECTIONS: AdminSection[] = [
  { path: '/', title: 'Дашборд', navLabel: 'Дашборд', icon: LineChart },
  { path: '/subscriptions', title: 'Подписки', navLabel: 'Подписки', icon: Sparkles },
  { path: '/categories', title: 'Категории', navLabel: 'Категории', icon: LayoutGrid },
  { path: '/merchants', title: 'Мерчанты', navLabel: 'Мерчанты', icon: Store },
  { path: '/products', title: 'Товары', navLabel: 'Товары', icon: ShoppingBag },
  { path: '/updates', title: 'Обновления', navLabel: 'Обновления', icon: ArrowUpCircle },
  { path: '/push', title: 'Push-рассылка', navLabel: 'Push', icon: Bell },
  { path: '/audit-log', title: 'Журнал', navLabel: 'Журнал', icon: History },
]

export function sectionByPath(pathname: string): AdminSection {
  const exact = ADMIN_SECTIONS.find((section) => section.path === pathname)
  if (exact) return exact
  const nested = ADMIN_SECTIONS.find(
    (section) => section.path !== '/' && pathname.startsWith(`${section.path}/`),
  )
  return nested ?? ADMIN_SECTIONS[0]
}
